module.exports = __webpack_public_path__ + "static/img/drive-m@2x.b120e2ed.png";